'use strict';

module.exports = {
    init: function () {
        $(document).on('click', '.js-show-more-history, .js-show-more-store-order-history', function (e) {
            e.preventDefault();
            var $button = $(this);
            var url = $button.attr('data-action');
            var pageCount = $button.data('pagecount');
            var isOnlineOrder =  $(this).hasClass('js-show-more-history');
            pageCount = parseInt(pageCount, 10) + 1;
            $.spinner().start();

            $.ajax({
                url: url,
                type: 'get',
                data: {
                    pageCount: pageCount
                },
                success: function (data) {
                    $button.data('pagecount', pageCount);
                    if (data.orderHistoryListHtml) {
                        if (isOnlineOrder) {
                            $('.js-order-history-list').append(data.orderHistoryListHtml);
                        }
                        else {
                            $('.js-store-order-history-list').append(data.orderHistoryListHtml);
                        }
                    }
                    if (!data.showMore) {
                        $('.js-show-more-history').hide();
                        $('.js-show-more-store-order-history').hide();
                    }
                },
                error: function (err) {
                    var response = err.responseText ? JSON.parse(err.responseText) : '';
                    if (response && response.redirectUrl) {
                        var redirectUrl = response.redirectUrl;
                        window.location.replace(redirectUrl);
                    }
                },
                complete: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
